//
//
//
//
//
//
//
//
//
//
//
//
//

import SkillAdd from './SkillAdd';
import PersonalCard from '~/components/Card/PersonalCard';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Skill',
  components: { SkillAdd, PersonalCard },
  data() {
    return {
      dlgShow: false,
      editMode: false,
      currentItem: {},
    };
  },
  computed: {
    ...mapGetters('personal', ['resumeData']),
    dataForInfoList() {
      if (!this.resumeData.userSkillList) return [];
      const list = this.resumeData.userSkillList.map(item => {
        return item.skillThreeName;
      });
      return list;
    },
    skillIdList() {
      if (!this.resumeData.userSkillList) return [];
      return this.resumeData.userSkillList.map(item => {
        return item.skillThreeId;
      });
    },
  },
  methods: {
    ...mapActions('personal', ['setSkillList']),
    getSkillList() {
      this.$api('userGetSkillList').then(data => {
        this.setSkillList(data);
      });
    },
    openAdd() {
      this.currentItem = {
        skillIds: this.skillIdList,
      };
      this.dlgShow = true;
    },
  },
  mounted() {
    this.getSkillList();
  },
};
